import Items from "../../diseases/items/items";
import { Link } from "react-router-dom";
import { SectionHeader } from "../../global/section title";
//assets
import Blogs1 from "../../../assets/images/blogs1.png";
import Blogs2 from "../../../assets/images/blogs2.png";
import { Title } from "../../global/title/title";
import { Carousel } from "react-responsive-carousel";

export const Blogs = ({ items }) => {
  return (
    <div className="section container diseases-sec">
      <Title black="Popular & Trending" blue="Blogs" />
      <Carousel infiniteLoop useKeyboardArrows autoPlay>
        <Items list={items.slice(0, 2)} search={false} />
        <Items list={items.slice(2, 4)} search={false} />
      </Carousel>
      <div className="text">
        <Link to="/blogs" className="heading__ternary  text--blue">
          see all
        </Link>
      </div>
    </div>
  );
};
const list = [
  {
    id: 1,
    title: "Event name",
    img: Blogs1,
    paragraph:
      "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.",
  },
  {
    id: 2,
    title: "Event name",
    img: Blogs2,
    paragraph:
      "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.",
  },
];
const list2 = [
  {
    id: 1,
    title: "Event name",
    img: Blogs1,
    paragraph:
      "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.",
  },
  {
    id: 2,
    title: "Event name",
    img: Blogs2,
    paragraph:
      "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.",
  },
];
